module.exports = __webpack_public_path__ + "static/Booklet-825-06-1dac816614ba916bc40e83f9d715ba09.png";